'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencyInput = function (_React$Component) {
    _inherits(CurrencyInput, _React$Component);

    function CurrencyInput() {
        _classCallCheck(this, CurrencyInput);

        return _possibleConstructorReturn(this, (CurrencyInput.__proto__ || Object.getPrototypeOf(CurrencyInput)).apply(this, arguments));
    }

    _createClass(CurrencyInput, [{
        key: 'onBlur',
        value: function onBlur(e) {
            var _props = this.props,
                precision = _props.precision,
                decimalSeparator = _props.decimalSeparator,
                onBlur = _props.onBlur;

            var raw = parseFloat(e.target.value);
            if (!raw) {
                e.target.value = 0..toFixed(precision).replace('.', decimalSeparator);
            } else {
                e.target.value = raw.toFixed(precision).replace('.', decimalSeparator);
            }
            onBlur(e);
        }
    }, {
        key: 'render',
        value: function render() {
            var props = (0, _utils.omit)(this.props, ['decimalSeparator', 'precision']);
            return _react2.default.createElement(_input2.default, _extends({}, props, { onBlur: this.onBlur.bind(this) }));
        }
    }]);

    return CurrencyInput;
}(_react2.default.Component);

exports.default = CurrencyInput;


CurrencyInput.propTypes = {
    addonBefore: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
    precision: _react2.default.PropTypes.number,
    decimalSeparator: _react2.default.PropTypes.string,
    type: _react2.default.PropTypes.string
};
CurrencyInput.defaultProps = {
    addonBefore: '￥',
    precision: 2,
    decimalSeparator: '.',
    type: 'text'
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/currency_input.js
// module id = 1335
// module chunks = 0